import styles from 'styles/modules/popUps/Alert.module.scss';
import Button from 'components/Button';

export default function Alert(props) {
    const { isActive, alertMessage, onCancel } = props;

    // Hidden by opacity alone, so without this the "has been added" heading and
    // Continue button land in the server HTML of every page that mounts an Alert.
    if (!alertMessage) return null;

    return (
        <div
            className={[styles.wrapper, isActive ? styles.isActive : null].join(
                ' '
            )}
        >
            <div className={styles.popUp}>
                <h4 className={styles.title}>
                    {alertMessage}
                    <br />
                    has been added
                </h4>

                <Button title={'Continue'} onClick={onCancel} />
            </div>
        </div>
    );
}
